import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

import { useMenu } from '@entities/Menu'

import { useFeedbackModal } from '@features/feedback'

import { AppMarket } from '@widgets/app-market'
import { SocialList } from '@widgets/social-list'


import { CONTACTS, URL_PAGE_AGREEMENT, URL_PAGE_POLICY } from '@shared/contants'
import { cn } from '@shared/lib/cn'
import Button from '@shared/ui/button'
import Container from '@shared/ui/container'

import ContactBlock from './contact-block'

import styles from './styles.module.scss'

export default function Footer () {
  const { t: tc } = useTranslation('common')
  const { openFeedbackModal } = useFeedbackModal()
  const { menu } = useMenu({ code: 'header-top' })

  return (
    <footer className={styles.root}>
      <Container>
        <div className={styles.root__inner}>
          <div className={styles.root__top}>
            <nav className={styles.root__nav}>
              {menu?.menuItems && menu.menuItems.length > 0 && (
                <div className={styles['root__nav-group']}>
                  <ul className={cn('reset-list', styles['root__nav-list'])}>
                    {menu.menuItems.map((item) => (
                      <li className={styles['root__nav-item']} key={item.id}>
                        <Link
                          className={styles['root__nav-link']}
                          to={item.link_url || '#'}
                        >
                          {item.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </nav>

            <div>
              <div className={styles.root__contacts}>
                {CONTACTS.supportBlocks.map((blockData) => <ContactBlock
                  title={tc(blockData.title)}
                  footer={blockData.footer ? tc(blockData.footer) : undefined}
                  contacts={blockData.contacts}
                />)}
              </div>

              <div className={styles.root__feedback}>
                <Button
                  className={styles['root__feedback-button']}
                  theme="grey"
                  onClick={openFeedbackModal}
                >
                  {tc('feedback.button')}
                </Button>
              </div>
            </div>
          </div>

          <div className={styles.root__middle}>
            <div className={styles.root__app}>
              <h3 className={cn(styles.root__title, styles['root__app-title'])}>
                {tc('app.title')}
              </h3>
              <AppMarket />
            </div>

            <div className={styles.root__social}>
              <h3 className={cn(styles.root__title, styles._subtitle)}>
                {tc('social.title')}
              </h3>
              <SocialList />
            </div>
          </div>

          <div className={styles.root__bottom}>
            <p
              className={cn(styles['root__bottom-text'], styles['_copyright'])}
            >
              ©{format(new Date(), 'yyyy')}. {tc('footer.shop')}{' '}
            </p>
            <Link to={URL_PAGE_AGREEMENT} className={styles['root__bottom-text']}>
              {tc('user.agreement')}
            </Link>
            <Link
              to={URL_PAGE_POLICY}
              className={cn(styles['root__bottom-text'], styles['_policy'])}
            >
              {tc('privacy.policy')}
            </Link>
          </div>
        </div>
      </Container>
    </footer>
  )
}
